import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Confirm from 'react-confirm-bootstrap';
import get from 'lodash/get';
import { show } from 'redux-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '../../../../components/common';
import { AdvertiserApi } from '../../../../api';
import JobsForm from '../../../../components/advertisers/jobs/JobsForm';
import UploadPopup from '../../../../components/advertisers/jobs/UploadPopup';
import SearchForm from '../../../../components/advertisers/jobs/SearchForm';
import { ButtonDelete, ButtonEdit } from '../../../../components/common/buttons/actions';
import { ButtonTrash } from '../../../../components/common/buttons';
import ButtonUpload from '../../../../components/common/buttons/ButtonUpload';

class Index extends Component {
  state = { searchInput: '' };

  getLocations(q, callback) {
    if (q.length) {
      if (!this.autocompleteService && window.google && window.google.maps) {
        this.autocompleteService = new window.google.maps.places
          .AutocompleteService();
      }
      if (this.autocompleteService) {
        this.autocompleteService.getPlacePredictions(
          {
            input: q,
            types: ['(regions)'],
            componentRestrictions: { country: 'us' }
          },
          predictions => {
            let options = [];
            if (predictions) {
              options = predictions.map(prediction => ({
                label: prediction.description,
                value: prediction.description
              }));
            }
            callback(null, { options });
          }
        );
      } else {
        callback(null, { options: [] });
      }
    } else {
      callback(null, { options: [] });
    }
  }

  selectedJobsDelete() {
    const { dispatch, account } = this.props;
    const ids = get(this.refs, 'allAccountJobsTable.state.selectedRowKeys', []);
    const params = { account_id: account.id };
    const data = { ids };
    if (ids.length) {
      dispatch(AdvertiserApi.actions.bulkJobsDelete.delete(params, data, (error, success) => {
        if (success) {
          this.fetchResource(params);
        }
        this.refs.allAccountJobsTable.state.selectedRowKeys = [];
      }));
    }
  }

  handleOnPageChange(page, per_page) {
    const { category, query, location } = this.props;
    this.fetchResource({
      page,
      per_page,
      category,
      query,
      location
    });
  }

  handleJobEdit(r) {
    const { dispatch, account } = this.props;
    dispatch(show('JobFormModal', {
      heading: 'Update Job',
      formAction: 'Update',
      job: r,
      account
    }));
  }

  handleJobDelete(r) {
    const { dispatch, account } = this.props;
    const data = { id: r.id, account_id: account.uuid };
    dispatch(AdvertiserApi.actions.jobDelete.delete(data, (error, success) => {
      if (success) {
        dispatch(AdvertiserApi.actions.jobs.get({ account_id: account.uuid }));
      }
    }));
  }

  showJobUpload() {
    const { dispatch, account } = this.props;
    if (account.uuid) {
      dispatch(show('UploadJobsPopModal', { account }));
    }
  }

  fetchResource(params = {}) {
    const { account, dispatch } = this.props;
    if (account.uuid) {
      const data = { ...params, account_id: account.uuid };
      dispatch(AdvertiserApi.actions.jobs.get(data));
    }
  }

  renderActions = (r) => {
    return (
      <ul className='list-inline'>
        <li>
          <ButtonEdit
            onClick={this.handleJobEdit.bind(this, r)}
          />
        </li>
        <li>
          <Confirm
            onConfirm={this.handleJobDelete.bind(this, r)}
            body='Are you sure you want to delete this job? Doing so will not remove it from current campaigns'
            confirmText='Confirm Delete'
            title={'Deleting Selected Jobs'}
          >
            <div><ButtonDelete /></div>
          </Confirm>
        </li>
      </ul>
    );
  }

  render() {
    const {
      account,
      jobs,
      jobsLoading
    } = this.props;
    const selectRow = {
      mode: 'checkbox'
    };
    const { data, meta } = jobs || {};
    const { pagination } = meta || {};
    const totalCount = get(pagination, 'total_count', null);
    const perPageList = [10, 20, 50, 100];
    const fetchInfo = {
      dataTotalSize: totalCount || 0
    };
    const options = {
      sizePerPage: get(pagination, 'per_page', 20),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: perPageList,
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1)
    };


    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>Job Inventory</h5>
        </div>
        <div style={{ background: 'white', paddingLeft: '20px', paddingRight: '20px' }}>
          <SearchForm account={account} getLocations={this.getLocations.bind(this)} />
        </div>
        <div className={`p-b-lg ibox-content${jobsLoading ? ' sk-loading' : ''}`}>
          <ButtonUpload
            btnLabel='Upload Jobs from file'
            onClick={this.showJobUpload.bind(this)}
          />
          <Confirm
            onConfirm={this.selectedJobsDelete.bind(this)}
            body='Are you sure you want to delete selected jobs? Doing so will not delete them from existing campaigns'
            confirmText='Confirm Delete'
            title={'Deleting Job'}
          >
            <div className="pull-right">
              <ButtonTrash
                bsStyle='danger'
                btnLabel='Delete Selected'
              />
            </div>
          </Confirm>
          <br />
          <UploadPopup />
          <Spinner />
          <br />
          <BootstrapTable
            striped
            ref='allAccountJobsTable'
            data={data || []}
            remote
            pagination
            selectRow={selectRow}
            fetchInfo={fetchInfo}
            options={options}
          >
            <TableHeaderColumn
              width="300"
              dataField="title"
              dataFormat={(c, r) =>
                <a onClick={this.handleJobEdit.bind(this, r)}>{c}</a>
              }
            >
              Title
            </TableHeaderColumn>
            <TableHeaderColumn
              width="150"
              dataField="category"
              dataFormat={(c) =>
                c
              }
            >
              Category
            </TableHeaderColumn>

            <TableHeaderColumn
              width="100"
              dataField="city"
              dataFormat={(c) => c}
            >
              City
            </TableHeaderColumn>
            <TableHeaderColumn
              width="200"
              dataField="url"
              dataFormat={(c) => {
                return (
                  <div>
                    <a rel='noopener noreferrer' target='_blank' href={c}>
                      <FontAwesomeIcon
                        icon="external-link-alt"
                        style={{ marginRight: '4px' }}
                      />
                      {c}
                    </a>
                  </div>
                );
              }}
            >
              URL
            </TableHeaderColumn>
            <TableHeaderColumn
              isKey
              width='75'
              dataField='id'
              dataFormat={(c, r) => this.renderActions(r)}
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
          <br />

          <JobsForm />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { advertiser: { jobs: { data: jobs, loading: jobsLoading }, accounts } } = state;
  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};
  return {
    account,
    jobs: jobs || {},
    jobsLoading: jobsLoading || get(state, 'loader').includes('JobUploadPop'),
    category: get(state, 'form.SearchForm.values.category', []),
    query: get(state, 'form.SearchForm.values.query', ''),
    location: get(state, 'form.SearchForm.values.location', ''),

  };
};
export default connect(mapStateToProps)(Index);
